import axios from "axios"
import { isEmpty, isUndefined } from "lodash"
import authHeader from "./jwt-token-access/auth-token-header"
//import { browserHistory } from "react-router"
//import { useHistory } from "react-router-dom"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
//pass new generated access token here
const accessToken = authHeader()


const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})

axiosApi.defaults.headers.common["source"] = "cms"

if (accessToken && !isUndefined(accessToken.Authorization)) {
  axiosApi.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${accessToken.Authorization}`
  axiosApi.defaults.headers.common["UserId"] = accessToken?.userId || ""
}

axiosApi.interceptors.response.use(
  response => response,
  error => Promise.reject(error)
)

export async function get(url, config = {}) {
  if (
    isEmpty(accessToken) &&
    isUndefined(axiosApi.defaults.headers.common["Authorization"])
  ) {
    const authToken = authHeader()
    axiosApi.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${authToken.Authorization}`
    axiosApi.defaults.headers.common["UserId"] = authToken?.userId || ""
  }

  return await axiosApi
    .get(url, { ...config })
    .then(response => {
      return response.data
    })
    .catch(err => {
      console.log("err", err?.response?.status)
      if (
        err?.response?.status == 401 &&
        err?.response?.statusText == "Unauthorized"
      ) {
        localStorage.clear()
        window.location.href = "/login"
      }
      return false
    })
}

export async function post(url, data, config = {}) {
  return axiosApi
    .post(url, { ...data }, { ...config })
    .then(response => response.data)
    .catch(err => {
      if (err?.response?.status == 401 || err?.response?.status == 403) {
        if(err?.response?.data?.message && err?.response?.config?.url === "/auth/login"){
          toastr.error(err?.response?.data?.message, "");
          localStorage.clear();
        }else{
          toastr.error("Session Expired. Please login again", "");
          localStorage.clear();
          setTimeout(() => {
            window.location.href = "/login";
          }, 500);
        }
      } else if (err?.response?.status == 404) {
        toastr.error("404 Not Found", "");
      }
    })
}

export async function put(url, config, data) {
  return axiosApi.put(url, config, { ...data }).then(response => response.data).catch(err => {
    if (err?.response?.status == 401 || err?.response?.status == 403) {
      toastr.error("Session Expired. Please login again", "");
      localStorage.clear();
      window.location.href = "/login";
    }
  });
}

export async function del(url, config = {}) {
  return await axiosApi
    .delete(url, { ...config })
    .then(response => response.data)
}
